import { lazy, Suspense } from "react";
import HeroSection from "./HeroSection";
import { Helmet } from "react-helmet";

const OverviewSection = lazy(() => import("./OverviewSection"));
const BestPartsSection = lazy(() => import("./BestPartsSection"));
const BenefitsSection = lazy(() => import("./BenefitsSection"));
const InnovationsSection = lazy(() => import("./InnovationsSection"));

const WebDevelopment = () => {
  return (
    <>
      <Helmet>
        <title>
          Web Development Services | Scalable & Responsive Solutions by Lentera
        </title>
        <meta
          name="description"
          content="Lentera Technologies builds secure, scalable, and responsive web applications with custom design, strong performance, and seamless cross-platform experiences."
        />
        <meta
          name="keywords"
          content="Lentera Technologies, custom web applications, responsive web design, scalable web solutions, secure web apps, UI/UX design, web app performance, cross-platform web apps."
        />
      </Helmet>
      
      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <OverviewSection />
        <BestPartsSection />
        <BenefitsSection />
        <InnovationsSection />
      </Suspense>
    </>
  );
};

export default WebDevelopment;
